import { render, staticRenderFns } from "./CourseChoice.vue?vue&type=template&id=acce0f12&scoped=true&"
import script from "./CourseChoice.vue?vue&type=script&lang=js&"
export * from "./CourseChoice.vue?vue&type=script&lang=js&"
import style0 from "./CourseChoice.vue?vue&type=style&index=0&id=acce0f12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acce0f12",
  null
  
)

export default component.exports